import type { ComponentProps, Ref } from 'react'
import cn from '@components/utils/cn'

const Input = ({ className, type, ref, ...props }: ComponentProps<'input'> & { ref?: Ref<HTMLInputElement> }) => (
  <input
    type={type}
    ref={ref}
    className={cn(
      'tw:flex tw:h-10 tw:w-full tw:rounded-md tw:border tw:border-gray-300 tw:bg-white tw:px-3 tw:py-2 tw:text-sm tw:placeholder:text-gray-400 tw:focus-visible:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-primary-500 tw:disabled:cursor-not-allowed tw:disabled:opacity-50',
      className
    )}
    {...props}
  />
)

export { Input }
